import apiClient from '@strava/api/lib/axios-client';

type SubmitFormDataSuccessResponse = {
  success: boolean;
  pathType: string;
  load: string;
};

type SubmitFormDataErrorResponse = {
  error: string;
};

type SubmitFormDataResponseType =
  | SubmitFormDataSuccessResponse
  | SubmitFormDataErrorResponse;

export const submitFormData = async ({
  formData,
  url,
  logError
}: {
  formData: FormData;
  url: string;
  logError: (s: string | unknown) => void;
}): Promise<SubmitFormDataResponseType> => {
  return new Promise((resolve, reject) => {
    apiClient({
      options: {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    })
      .post(url, formData)
      .then((response: { data: SubmitFormDataResponseType }) => {
        resolve(response.data);
      })
      .catch((error: unknown) => {
        logError(error);
        reject(error);
      });
  });
};

export const isAlreadyRegisteredEmail = async (email: string) => {
  return new Promise((resolve, reject) => {
    apiClient()
      .get('/athletes/email_unique', { params: { email } })
      .then(({ data }: { data: boolean }) => {
        resolve(data);
      })
      .catch((error: unknown) => {
        reject(error);
      });
  });
};
